import React, {ReactElement, ReactNode} from 'react';

import './InfoImageBlock.scss';

export interface InfoImageBlockProps {
  infoBlock: ReactNode;
  imageBlock: ReactNode;
  className?: string;
  isReversed?: boolean;
}

function InfoImageBlock({infoBlock, imageBlock, className, isReversed}: InfoImageBlockProps): ReactElement {
  return (
    <div className={`infoImageBlock ${isReversed ? 'infoImageBlock__isReversed' : ''} ${className || ''}`.trim()}>
      <div className="infoImageBlock__infoContainer">{infoBlock}</div>
      <div className="infoImageBlock__imageContainer">{imageBlock}</div>
    </div>
  );
}

export default InfoImageBlock;
